import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/918989911780"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-20 right-4 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-all group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={20} strokeWidth={1.5} className="flex-shrink-0" />
      <span className="hidden sm:inline text-sm font-medium font-body">
        WhatsApp Us
      </span>
    </a>
  );
}
